import Col from '../Col2.js';
import Date_mm_dd_yyyy_Base from './FieldTypeBase/Date_mm-dd-yyyy_Base.js';

const Date_mm_dd_yyyy_Block = (props) => {
    return (
         <Col           
            key={props.objectkey} 
            id={props.objectkey}          
            className={`col-md-${props.field.width} field ${props.field.class || ""}`}>

            <Date_mm_dd_yyyy_Base {...props}></Date_mm_dd_yyyy_Base> 

        </Col>

    );
}

export default Date_mm_dd_yyyy_Block;